import { render, staticRenderFns } from "./IsRequesting.vue?vue&type=template&id=1facd5c8"
import script from "./IsRequesting.vue?vue&type=script&lang=js"
export * from "./IsRequesting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports